// extracted by mini-css-extract-plugin
export default {"heading":"vmQ4Ro","checkbox":"O6DwGr"};